import { BrowserName, getBrowserName } from '../browser-name';
let textSelection;
let textRange;
let needSaveTextSelection = false;

/* 
  In Firefox and Safari, text selection will be clear when setting focus using js.
  So, we need to save the text selection before setting focus and restore it afterwards.
*/
export const saveTextSelection = (isOpenContextMenu = false) => {
  if (getBrowserName() === BrowserName.Firefox || getBrowserName() === BrowserName.Safari) {
    if (!isOpenContextMenu) {
      textSelection = null;
      textRange = null;
    }
    const selection = window.getSelection();
    if ((!isOpenContextMenu || needSaveTextSelection) && selection && selection.rangeCount > 0) {
      textSelection = selection;
      textRange = selection.getRangeAt(0);
    }
    needSaveTextSelection = false;
  }
};
export const restoreTextSelection = () => {
  if (textSelection && textRange) {
    textSelection.removeAllRanges();
    textSelection.addRange(textRange);
    textSelection = null;
    textRange = null;
  }
};
export const setNeedSaveTextSelection = val => {
  needSaveTextSelection = val;
};
//# sourceMappingURL=selectionCompatibility.js.map